import { useState, useEffect } from "react";

// Per-station running tally of Zebra labels SENT today. Lives in localStorage so
// it survives reloads and is shared across tabs on the same print station; it
// auto-resets at midnight (keyed by local date). The point is stock-waste
// awareness — an accidental over-print makes this number jump.
const KEY = "fas_labels_today";
const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const listeners = new Set();

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "null");
    if (raw && raw.date === today()) return raw.count || 0;
  } catch { /* ignore */ }
  return 0;
}

function write(count) {
  try { localStorage.setItem(KEY, JSON.stringify({ date: today(), count })); } catch { /* ignore */ }
  listeners.forEach((fn) => fn(count));
}

export function getLabelsToday() { return read(); }

export function recordLabelsSent(n = 1) {
  const next = read() + n;   // read() auto-resets the tally when the date rolls over
  write(next);
  return next;
}

export function resetLabelsToday() { write(0); }

function subscribe(fn) {
  listeners.add(fn);
  const onStorage = (e) => { if (e.key === KEY) fn(read()); };
  window.addEventListener("storage", onStorage);
  return () => { listeners.delete(fn); window.removeEventListener("storage", onStorage); };
}

export function useLabelsToday() {
  const [n, setN] = useState(getLabelsToday());
  useEffect(() => subscribe(setN), []);
  return n;
}
